import { cn } from '@workspace/web-ui/lib/utils'
import { AppointmentDetailsAction } from './appointment-details-action'
import { EncounterMedicationRefillAction } from './refill-details-action'
import { ConsultationDetailsAction } from './consultation-details-action'
import { EncounterDetailsContentProps } from '../encounter-details'
import UrgentCareSessionDetails from '../../../patient-logs/components/urgent-care-session-details'

export const EncounterDetailsAction = ({ encounter, className, patientSummary, program }: EncounterDetailsContentProps) => {
    return (
        <div className={cn(className)}>
            {encounter.type === "appointment" && <AppointmentDetailsAction encounter={encounter} />}
            {encounter.type === "refill" && <EncounterMedicationRefillAction encounter={encounter} />}
            {program !== "urgent-care" && encounter.type === "consultation" && <ConsultationDetailsAction encounter={encounter} />}
            {program === "urgent-care" && encounter.type === "consultation" && patientSummary && <UrgentCareSessionDetails patient={patientSummary} session={encounter} fromPage={true} />}
        </div>
    )
}
